<template>
    <div class="control">
        <div class="tags has-addons are-medium">
            <span class="tag" :class="counterClass">{{ text }}</span>
            <span class="tag is-white">{{ counter }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "auto-seeding-status-summary",
        props: ["counter", "text", "counterClass"],
    };
</script>

<style scoped></style>
